import { render, staticRenderFns } from "./account-setting.vue?vue&type=template&id=7212d44a&"
import script from "./account-setting.vue?vue&type=script&lang=js&"
export * from "./account-setting.vue?vue&type=script&lang=js&"
import style0 from "./account-setting.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports